export const radii = {
    tileImage: {
        value: '0.375rem',
    },
    tile: {
        value: '0.625rem',
    },
};
